import { Players } from "./PlayersEntries.js";
const fallback = Players()[0];
const getActivePlayer = (allowDirectVideoLinks, src)=>{
    for (const player of Players(allowDirectVideoLinks))if (src && player.canPlay(src)) return player;
    if (fallback) return fallback;
    return null;
};
export { getActivePlayer };
